var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoMapExportstop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.714 155.003V107.298L201.858 131.147L167.765 97.0545L232.777 32.0597C237.297 27.5394 243.428 25 249.821 25C256.214 25 262.345 27.5394 266.865 32.0597L331.762 96.9391L297.669 131.032L273.928 107.298V154.772L249.706 178.995L225.714 155.003ZM332.478 237.644L376.371 193.751H394.464C405.116 193.763 415.328 198 422.861 205.532C430.393 213.064 434.63 223.277 434.642 233.929V363.931L386.428 315.717V241.965H346.249C341.292 241.965 336.492 240.438 332.478 237.644ZM143.336 426.786H356.075L384.056 454.767C392.74 463.451 403.824 468.273 415.172 469.232C408.972 472.967 401.823 474.992 394.464 475H105.178C97.8079 474.992 90.6479 472.961 84.4406 469.215C95.719 468.215 106.723 463.399 115.355 454.767L143.336 426.786ZM167.028 237.738C163.042 240.472 158.294 241.965 153.393 241.965H113.214V315.486L65 363.701V233.929C65.012 223.277 69.249 213.064 76.7813 205.532C84.3136 198 94.5262 193.763 105.178 193.751H123.04L167.028 237.738Z",
    fill: "#333333",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80 80L419.411 419.411",
    stroke: "#333333",
    strokeWidth: 60,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M419.411 80L79.9999 419.411",
    stroke: "#333333",
    strokeWidth: 60,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMapExportstop);
export default __webpack_public_path__ + "static/media/ico_map_exportstop.49217a19cb018d2a85d6a2e65cf3dfcd.svg";
export { ForwardRef as ReactComponent };